
import { useProgramsFetch } from "./useProgramsFetch";
import { useProgramsSelection } from "./useProgramsSelection";
import { useProgramsDelete } from "./useProgramsDelete";

export function useProgramsData() {
  // Get programs data and loading state
  const { programs, isLoading, fetchPrograms } = useProgramsFetch();
  
  // Handle program selection and search
  const { 
    searchQuery, 
    setSearchQuery,
    selectedPrograms, 
    filteredPrograms,
    toggleProgramSelection,
    toggleSelectAll 
  } = useProgramsSelection(programs);
  
  // Handle program deletion
  const { isDeleting, handleDeleteSelectedPrograms } = useProgramsDelete(fetchPrograms);

  // Adapter function to maintain API compatibility
  const handleDeleteSelected = async () => {
    return await handleDeleteSelectedPrograms(selectedPrograms);
  };

  return {
    programs,
    isLoading,
    searchQuery,
    setSearchQuery,
    selectedPrograms,
    filteredPrograms,
    toggleProgramSelection,
    toggleSelectAll,
    handleDeleteSelectedPrograms: handleDeleteSelected,
    fetchPrograms
  };
}
